import { action, observable, makeObservable, computed } from 'mobx';

import { parseNumberByPrecision } from '../core/helpers/parseNumberByPrecision';

import { applicationStore } from './applicationStore';

class UserInfoStore {
  userId = null;

  currencyIcon = '';

  userBalance = 0;

  demoBalance = 100000;

  limits = {};

  precision = 2;

  rate = 1;

  currencySymbolOrCode = '';

  betReplayTokenBySpin = '';

  isReplay = false;

  constructor() {
    makeObservable(this, {
      rate: observable,
      userId: observable,
      limits: observable,
      isReplay: observable,
      precision: observable,
      userBalance: observable,
      demoBalance: observable,
      currencyIcon: observable,
      betReplayTokenBySpin: observable,
      currencySymbolOrCode: observable,
      balance: computed,
      setRate: action.bound,
      setUserId: action.bound,
      setLimits: action.bound,
      setIsReplay: action.bound,
      setPrecision: action.bound,
      setDemoBalance: action.bound,
      setUserConfigs: action.bound,
      setUserBalance: action.bound,
      setCurrencyIcon: action.bound,
      setCurrencySymbolOrCode: action.bound,
      setBetReplayTokenBySpin: action.bound,
    });
  }

  get balance() {
    return this.userBalance;
  }

  setBetReplayTokenBySpin(token) {
    this.betReplayTokenBySpin = token;
  }

  setIsReplay(bool) {
    this.isReplay = bool;
  }

  setCurrencyIcon(bool) {
    this.currencyIcon = bool;
  }

  get currencySymbol() {
    return this.currencySymbolOrCode;
  }

  // eslint-disable-next-line grouped-accessor-pairs
  set balance(balance) {
    this.setUserBalance(balance);
  }

  setDemoBalance(demoBalance) {
    this.demoBalance = parseNumberByPrecision(demoBalance, 1, this.precision);
  }

  setRate(rate) {
    this.rate = rate;
  }

  setUserId(userId) {
    this.userId = userId;
  }

  setCurrencySymbolOrCode(currencyCode) {
    this.currencySymbolOrCode = currencyCode;
  }

  setPrecision(precision) {
    this.precision = precision;
  }

  setLimits(limits) {
    this.limits = limits;
  }

  setUserBalance(balance) {
    this.userBalance = balance;
  }

  setUserConfigs({ rate, balance, precision, limits }) {
    this.setUserBalance(balance);
    this.setPrecision(precision);
    this.setLimits(limits);
    this.setRate(rate);
  }

  decreaseBalance(spinAmount, balance) {
    this.balance = balance;
  }
}

export const userInfoStore = new UserInfoStore();
